<template>
  <div class="widM padTM pf23Wrap padBML" >
    <div class="txtC padBM" style="border-bottom:1px solid #ddd;">
      <img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_amway_ci.png" alt="Amway (로고)" class="icoS"
        style="max-width:115px;">
    </div>
    <p class="pf23-tit fntH4 fntL bold marBS padTML txtC" style="color:#00305e; letter-spacing: normal;">{{titleName}}</p>
    <p class="pf23-tit fntH4 marBL txtC" style="color:#2c2c2c; letter-spacing: normal;">{{titleDesciption}}</p>
    <div class="pf23-inFo-wrap">
      <div class="widM clearfix">
        <template v-for="(attend, idx) in attendingList">
          <hr :key="`hr-${idx}`" v-if="idx > 0" class="moOnly" style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;">
          <div class="widM" :key="idx" :class="{'floL' : (idx % 2 == 0), 'floR' : (idx % 2 == 1)}">
            <p class="fntH6 fntL bold marBM" style="color:#2c2c2c; width:49%;">{{aboType(idx)}}</p>
      
            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx % 2 ==0), 'pf23-complet-R' : (idx % 2 == 1)}">
              <label for="pf23Name01" class="fntP">이름</label>
              <input type="text" id="pf23Name01" name="pf23Name01" :value="aboName(idx)">
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx % 2 ==0), 'pf23-complet-R' : (idx % 2 == 1)}">
              <label for="pf23Abo01" class="fntP">ABO 번호</label>
              <input type="text" id="pf23Abo01" name="pf23Abo01" :value="aboNumber(idx)">
            </div>

            <!-- 기본 설문 정보 -->
            <template v-for="(question, index) in  infoQuestions">
              <div v-if="!ingoreInfoQuestion.includes(question.sq_code)" :key="`${idx}-${question}-${index}`" class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx % 2==0), 'pf23-complet-R' : (idx % 2==1)}">
                <label for="pf23Num01" class="fntP">{{question.title}}</label>
                <input type="text" id="pf23Num01" name="pf23Num01" :value="`${answer(idx, question.sq_code)}`">
              </div>
            </template>

            <!-- 액티비티 정보 -->
            <template v-for="(question, index) in  activityQuestions" >
              <div v-if="activityAvailable" :key="`${idx}-${question}-${index}`" class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx % 2==0), 'pf23-complet-R' : (idx % 2==1)}">
                <label for="pf23Num01" class="fntP">{{question.title}}</label>
                <input type="text" id="pf23Passport-date01" name="pf23Passport-date01" :value="activityAnswer(idx, question.sq_code)" >
              </div>
            </template>
          </div>
        </template>
    
      </div>

      <!-- 추가 결제 정보 -->
      <div class="widM clearfix" v-if="isPayment">
        <hr class="moOnly" style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;">
        <div>
          <p class="fntH6 fntL bold marBM" style="color:#2c2c2c; width:100%;">추가 결제 정보 </p>
    
          <div class="padBSM padTSM pf23-complet-common pf23-lineBtm paymentinfo" >
            <label for="pf23PaymentCredit1" class="fntP">결제 방식</label>
            <input type="text" id="pf23PaymentCredit1" name="pf23PaymentCredit1" :value="paymentType()">
          </div>

          <template v-if="isPaymentTypeCard">
            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm paymentinfo" >
              <label for="pf23PaymentCredit2" >결제 정보 수신 연락처</label>
              <input type="text" id="pf23PaymentCredit2" name="pf23PaymentCredit2" :value="paymentRemark()">
              <p>리더님의 소중한 개인정보 보호를 위해 모든 결제는 ARS 결제로 진행됩니다. 추후 발송되는 결제요청 문자의 발신번호로 전화를 걸어 안내멘트에 따라 ARS 결제를 부탁드립니다. 결제요청 문자는 1월부터 순차적으로 발송될 예정입니다. </p>
            </div>
          </template>

          <template v-if="!isPaymentTypeCard">
            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm paymentinfo" >
              <label for="pf23PaymentDirect1" class="fntP">은행 및 계좌번호</label>
              <input type="text" id="pf23PaymentDirect1" name="pf23PaymentDirect1" :value="paymentGuide.DIRECT_BANK">
            </div>
            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm paymentinfo" >
              <label for="pf23PaymentDirect2" class="fntP">예금주</label>
              <input type="text" id="pf23PaymentDirect2" name="pf23PaymentDirect2" :value="paymentGuide.DIRECT_DEPOSITOR">
            </div>
            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm paymentinfo" >
              <label for="pf23PaymentDirect3" class="fntP">입금자명</label>
              <input type="text" id="pf23PaymentDirect3" name="pf23PaymentDirect3" :value="paymentRemark()">
            </div>
          </template>

        </div>
      </div>
    </div>
      
    <div class="widM txtC marTML">
      <button class="bt-akl-blue large pf23-submit" @click="$emit('edit', true)">{{buttonName}}</button>
      <p class="txtC padTS moTxtL">* 본 화면을 벗어나더라도 신청기간 내에 URL을 통해 다시 수정하실 수 있습니다.</p>
    </div>
    
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import {
  SURVEY_SAPPORO,
  ATTENDING_LIST,
  GET_CODE_COUNTRY,
  GET_CODE_ABO_TYPE,
  GET_CODE_GENDER ,
  GET_CODE_SPORT_LEVEL,
  SCHEDULE_QUESTIONS,
  ACTIVITY_QUESTIONS,
  INFO_QUESTIONS, 
  ACTIVITY_AVAILABLE,
  GET_CODE_PAYMENT_GUIDE,
} from '@/store/actions/survey'

export default {
  name: 'SurveyCompleted',
  data() {
    return { 
      answerMobile: ['Q200'], 
      answerCodeDomestic : ['Q201',], 
      answerCodeGender : ['Q206',], 
      answerCodeHeight : ['Q211',],
      answerCodeWeight : ['Q212',],
      answerCodeFootSize : ['Q213',], 
      answerCodeReportsLevel : ['Q215',], 
      answerJumin : ['Q202', 'Q203'], 
      answerBoolean : ['Q216', 'Q217'],
      ingoreInfoQuestion: ['Q220','Q221','Q222','Q223','Q224','Q225','Q203','Q218','Q216']
    }
  },
  props : {
    edit: {
      type: Boolean, 
      default: false
    },
    mode: {
      type: String, 
      default: 'E'
    }
  },
  computed : {
    ...mapState(SURVEY_SAPPORO, {
      wave_number: state => state.wave_number
    }),
    ...mapGetters(SURVEY_SAPPORO, {
      attendingList: ATTENDING_LIST,
      counties : GET_CODE_COUNTRY,
      aboTypes: GET_CODE_ABO_TYPE,
      codeGender: GET_CODE_GENDER ,
      codeReportsLevel: GET_CODE_SPORT_LEVEL,
      scheduleQuestions: SCHEDULE_QUESTIONS,
      activityQuestions: ACTIVITY_QUESTIONS,
      activityAvailable: ACTIVITY_AVAILABLE,
      infoQuestions: INFO_QUESTIONS,
      paymentGuide: GET_CODE_PAYMENT_GUIDE,
    }),
    editable() { 
      return this.edit || false
    },
    buttonName() { 
      if (!this.activityAvailable) return "수정하기"; 
      if (this.activityAvailable) { 
        return (this.attendingList[0].questions['Q230'][0].se_code ? "수정하기": "액티비티 신청하기")
      }
    },
    titleName() {
      if (!this.activityAvailable) return "신청이 완료되었습니다."; 
      if (this.activityAvailable) { 
        return (this.attendingList[0].questions['Q230'][0].se_code ? "신청이 완료되었습니다.": "")
      }
    },
    titleDesciption(){ 
      if (!this.activityAvailable) return "아래 신청 내용을 확인해 주세요."; 
      if (this.activityAvailable) { 
        return (this.attendingList[0].questions['Q230'][0].se_code ? "아래 신청 내용을 확인해 주세요.": "참가 신청 내역을 확인해주시고 페이지 하단 액티비티 신청하기 버튼을 통해 액티비티를 신청해주세요.")
      }
    },
    isPayment() { 
      return this.attendingList[0].payment_yn === 'Y'
    },
    isPaymentTypeCard() { 
      return this.attendingList[0].payment_type === 'CREDIT'
    }
  },
  methods: {
    aboType(idx){
      if (this.attendingList[idx].type === 'P') { 
        return `${this.aboTypes[this.attendingList[idx].type]} ${this.attendingList[idx].type_seq}`;
      } else if (this.attendingList[idx].type === 'F') { 
        // 공동사업자, 동반가족의 경우 넘버링 함께 표시 
        const mainResponseUnit = this.attendingList.filter(response => response.attendance_yn === 'Y' && response.type !== 'F').length;
        // index + 1 (0부터 시작되기 때문에 +1 을 해줌)  - mainResponseUnit (abo, 배우자 등의 인원을 - 해줌)
        const familyNumbering = idx + 1 - mainResponseUnit;
        
        return `${this.aboTypes[this.attendingList[idx].type]} ${familyNumbering}`;
      } else { 
        return this.aboTypes[this.attendingList[idx].type];
      }
    },
    aboName(idx) {
      return this.attendingList[idx]['name'];
    },
    aboNumber(idx) {
      return (this.attendingList[idx].type !== 'F' ? this.attendingList[idx]['abo_uid'] : '');
    },
    answer(idx, sq_code, ...suffix) {
      // 모바일 
      if (this.answerMobile.includes(sq_code)) return `010-${this.attendingList[idx].questions[sq_code].raw_data}`

      // boolean 
      if (this.answerBoolean.includes(sq_code)) return this.attendingList[idx].questions[sq_code].raw_data === 'Y' ? '예' : '아니오';  

      // 코드 - 내국인여부
      if (this.answerCodeDomestic.includes(sq_code)) return this.attendingList[idx].questions[sq_code].raw_data == 'DOMESTIC' ? '내국인' : '외국인';
      
      // 코드 - 성별
      if (this.answerCodeGender.includes(sq_code)) return this.codeGender[this.attendingList[idx].questions[sq_code].raw_data];

      // 코드 - 신장
      if (this.answerCodeHeight.includes(sq_code)) return `${this.attendingList[idx].questions[sq_code].raw_data} cm`;

      // 코드 - 체중
      if (this.answerCodeWeight.includes(sq_code)) return `${this.attendingList[idx].questions[sq_code].raw_data} kg`;

      // 코드 - 신발사이즈
      if (this.answerCodeFootSize.includes(sq_code)) return `${this.attendingList[idx].questions[sq_code].raw_data} mm`;

      // 코드 - 스키보드레벨
      if (this.answerCodeReportsLevel.includes(sq_code)) return this.codeReportsLevel.filter(level => level.CODE == this.attendingList[idx].questions[sq_code].raw_data).map(code => code.LABEL);

      // 주민번호 
      if (this.answerJumin.includes(sq_code)) return  `${this.attendingList[idx].questions[this.answerJumin[0]].raw_data} - ${this.attendingList[idx].questions[this.answerJumin[1]].raw_data}`

      return this.attendingList[idx].questions[sq_code].raw_data;
      
    },
    booleanAnswer(idx, sq_code) {
      return this.attendingList[idx].questions[sq_code].raw_data === 'Y' ? '예' : '아니오';
    },
    gender(idx, sq_code){  
      return this.genders[this.attendingList[idx].questions[sq_code].raw_data];
    },
    domestic(idx, sq_code) {
      return this.attendingList[idx].questions[sq_code].raw_data === 'DOMESTIC' ? '내국인' : '외국인';
    },
    scheduleAnswer(idx, sq_code){
      const data = this.attendingList[idx].questions[sq_code][0]
      if ( this.scheduleQuestions[data.sq_code]) {
        return this.scheduleQuestions[data.sq_code].examples[data.se_code].display_text;      
      } else { 
        return ''
      }
    },
    activityAnswer(idx, sq_code){
      const data = this.attendingList[idx].questions[sq_code][0]
      if ( this.activityQuestions[data.sq_code] && this.activityQuestions[data.sq_code].examples[data.se_code]) { 
        return this.activityQuestions[data.sq_code].examples[data.se_code].display_text;      
      } else {
        return '선택 안함'
      }
    },
    country(idx, sq_code) { 
      return this.attendingList[idx].questions[sq_code].raw_data === 'DOMESTIC' ? '주민등록번호' : '외국인등록번호';
    },
    visaEta(idx, visaEta) { 
      const isVisa = this.attendingList[idx].questions[visaEta].raw_data === 'Y';
      return (isVisa) ? `신청` : '미신청';
    },
    jumin(idx, ssn1, ssn2) { 
      return `${this.attendingList[idx].questions[ssn1].raw_data} - ${this.attendingList[idx].questions[ssn2].raw_data}`
    },
    paymentType(){ 
      return this.attendingList[0].payment_type === 'CREDIT' ? '신용카드' :  '계좌이체';
    },
    paymentRemark() {
      return `${this.attendingList[0].payment_type === 'CREDIT' ? '010-' : ''}${this.attendingList[0].payment_remark}`;
    }
  },
}
</script>

<style scoped>
.box_renew-loading .box_loading-area {
    display: flex;
    width: 80px;
    height: 80px;
    margin: auto;
    border-radius: 50%;
    background: #fff;
    justify-content: center;
    align-items: center;
    box-shadow: 1px 1px 20px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
}
.box_renew-loading .box_loading-area img {
  width: 60px;
}
.paymentinfo label{ 
  width: 48%;
}
.paymentinfo input {
  width: 50%;
}
.paymentinfo p {
  padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/surveys/sapporo/components/SurveyCompleted.vue